import { GRID_VIEW } from "../../utils/global_variables";
import { HOLDINGS, PORTFOLIO } from "../actionTypes";

const initialState = {
    portfolioSumaary: {},
    sunBurstData: [],
    equityData: [],
    mutualFundsData: [],
    holdingsView: GRID_VIEW.DEFAULT_VIEW
};



const portfolioReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case PORTFOLIO.GET_PORTFOLIO:
            return {
                ...state,
                portfolioSumaary: {
                    current_value: '1,40,765.82',
                    profit_loss: '(4.05%) +2,061.2',
                    total_invested: '1,40,000.00',
                    today_p_l: '+50.82 (2.45%)',
                    overall_p_l: '765.82',
                    equity: {
                        id: 'Equity',
                        total_invested: '111765.80',
                        profit_loss: '+2,061.2 (4.05%)'
                    },
                    mutual_funds: {
                        id: 'Mutual Funds',
                        total_invested: '29000',
                        profit_loss: '-4,061.2 (60.05%)'
                    },
                },
                sunBurstData: [{
                    id: '0',
                    parent: '',
                    name: ' ',
                },
                {
                    id: '1',
                    parent: '0',
                    name: 'Equity',
                    color: '#4285f4',

                },
                {
                    id: '2',
                    parent: '0',
                    name: 'Muthual Funds',
                    color: '#fce8b2'
                },
                {
                    id: '3',
                    parent: '1',
                    name: 'IT',
                    value: 100
                },
                {
                    id: '3.2',
                    parent: '1',
                    name: 'Consultant',
                    value: 25,
                },
                {
                    id: '3.3',
                    parent: '2',
                    name: 'long',
                    value: 25,
                },
                {
                    id: '3.4',
                    parent: '3.3',
                    name: 'axis',
                    value: 25,
                },
                {
                    id: '3.6',
                    parent: '3',
                    name: 'TCS',
                    value: 252,
                },
                {
                    id: '3.7',
                    parent: '3.2',
                    name: 'Wipro',
                    value: 210,
                },
                {
                    id: '3.8',
                    parent: '3',
                    name: 'Infosis',
                    value: 250,
                },
                ],
                equityData: [1020.38, 1030.48, 1050.38, 1040.48, 1030.38, 1023.48, 1044.38, 1060.48, 1065.38, 1067.48, 1055.38, 1043.48, 1022.38, 1033.48, 1040.38, 1045.48, 1050.38, 1055.48, 1060.38, 1065.48, 1070.38, 1075.48,],
                mutualFundsData: [1012.38, 1000.48, 1021.38, 1001.48, 1011.38, 1014.48, 1024.38, 1035.48, 1040.38, 1036.48, 1040.38, 1010.48, 1012.38, 1022.48, 1010.38, 1020.48, 1030.38, 1035.48, 1040.38, 1045.48, 1045.38, 1050.48,],


            };
        case HOLDINGS.UPDATE_HOLDING_VIEW:
            return {
                ...state, holdingsView: actions.payload
            }
        default:
            return state;
    }

};

export default portfolioReducer;